import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);

  useEffect(() => {
    function handleOffline() {
      setIsOffline(true);
      setShowBanner(true);
    }

    function handleOnline() {
      setIsOffline(false);
      const timer = setTimeout(() => setShowBanner(false), 3000);
      return () => clearTimeout(timer);
    }

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div
      className={`flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium transition-colors duration-500 ${
        isOffline
          ? 'bg-amber-500 text-white'
          : 'bg-emerald-500 text-white'
      }`}
    >
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      {isOffline
        ? 'Je bent offline. Je kunt eerder geladen gegevens nog bekijken.'
        : 'Verbinding hersteld.'}
    </div>
  );
}
